import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Alert } from '@frontend/design-system';
import { useGetUpdateOfficeHoursMethod } from '../../hooks/use-get-update-office-hours-method';
import { OfficeHoursSettings } from './OfficeHoursSettings';

type OfficeHoursSettingsProps = {
  locationId: string;
};

export const OfficeHoursGlobalSettings = ({ locationId }: OfficeHoursSettingsProps) => {
  const { t } = useTranslation('schedule');

  const { isSaving, onSave, isFetching, officeHoursData, hasOfficeHoursFetchError } =
    useGetUpdateOfficeHoursMethod(locationId);

  return (
    <>
      {hasOfficeHoursFetchError && (
        <Alert type='error' css={{ marginTop: theme.spacing(2) }}>
          {t('Unable to fetch appointment hours. Please try again later.')}
        </Alert>
      )}
      <OfficeHoursSettings
        locationId={locationId}
        isLoading={isFetching || isSaving}
        officeHoursData={officeHoursData}
        onSave={onSave}
      />
    </>
  );
};
